export const config = {
    backgroundImages: {},
    timeFormat: "HH:mm"
};
//# sourceMappingURL=config.js.map